var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.preloaderProps.title
        ? _c("preloader", {
            attrs: {
              title: _vm.preloaderProps.title,
              message: _vm.preloaderProps.message
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("payment-header", { attrs: { payable: _vm.payable } }),
      _vm._v(" "),
      _vm.payable.type === "orders"
        ? _c("order-data", { attrs: { order: _vm.payable } })
        : _vm._e(),
      _vm._v(" "),
      _vm.payable.type === "cycles"
        ? _c("cycle-data", { attrs: { cycle: _vm.payable } })
        : _vm._e(),
      _vm._v(" "),
      _vm.payable.type === "orders" &&
      (_vm.payable.coupon ||
        (_vm.payable.status != "created_on_gateway" &&
          !_vm.payable.payments.length))
        ? _c("coupon", {
            attrs: { order: _vm.payable },
            on: {
              couponApplied: function($event) {
                _vm.$emit("refresh")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.boleto
        ? _c("choose-payment", {
            attrs: { payable: _vm.payable, preloader: _vm.preloader },
            on: { selected: _vm.setPayment }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("boleto-confirmation", {
        attrs: { visible: _vm.showBoletoConfirmation, payable: _vm.payable },
        on: {
          cancelled: function($event) {
            _vm.showBoletoConfirmation = false
          },
          confirmed: _vm.createBoleto
        }
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "zoom", mode: "out-in" } },
        [
          _vm.payment === "credit_card"
            ? _c("credit-card", {
                attrs: { id: "payment-method", payable: _vm.payable }
              })
            : _vm.payment === "boleto" && _vm.boleto
              ? _c("boleto", {
                  attrs: { id: "payment-method", boleto: _vm.boleto }
                })
              : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cbd508a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cbd508a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payment/Index.vue
// module id = null
// module chunks = 